import { isWeekday, validateDeliveryDate } from '../../../cfi/material-order/functions/deliveryDate';
import { DeliveryDateSettings } from '../../../cfi/material-order/types/DeliveryDateSettings';
import { CfiRoutingType } from '../../cfi-routing/types/CfiRoutingType';
import { POProduct } from '../types/POProduct';

type ProductSchedule = Pick<POProduct, 'deliveryDateSettings'>;

// A product has its own schedule only when usp_sync_ORD_POProduct_GetList found an assignment row for it.
// When it did not, every DeliveryDateSettings* column is NULL (Task 4 turns that into a null object).
// A real row can have a NULL pattern (8 active rows locally), so test three columns, not just the pattern.
export function hasOwnDeliverySchedule(settings: DeliveryDateSettings | null | undefined): settings is DeliveryDateSettings {
	if (!settings) return false;
	return settings.recurrencePatternType != null
		|| settings.cutoffDaysBefore != null
		|| settings.rangeOfRecurrenceStartDate != null;
}

// Mirrors SubmitValidatedDeliveryDateCommandHandler + CfiRoutingService.GetRoutingScheduleForProductAsync:
// each product uses its own schedule when it has one and the CFI-level routing otherwise, and every product must accept the date.
export function isPurchaseOrderDeliveryDateAllowed(
	date: Date,
	products: ProductSchedule[] | undefined,
	cfiRouting: CfiRoutingType | undefined
): boolean {
	const fallback: DeliveryDateSettings | undefined = cfiRouting;
	const schedules = (products ?? []).map(product =>
		hasOwnDeliverySchedule(product.deliveryDateSettings) ? product.deliveryDateSettings : fallback);
	if (schedules.length === 0) {
		schedules.push(fallback);
	}
	return schedules.every(schedule => schedule ? validateDeliveryDate(date, schedule) : isWeekday(date));
}